import { SSOButton } from '@components/SSOButton';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const SSOButtonsSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="SSO Buttons"
      description="Social sign-in buttons for Google, Microsoft, and GitHub authentication."
      figmaNodeId="232-2152"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>All Providers</h3>
      <div className={styles.ssoButtonsDemo}>
        <SSOButton provider="google" />
        <SSOButton provider="microsoft" />
        <SSOButton provider="github" />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Custom Text</h3>
      <div className={styles.ssoButtonsDemo}>
        <SSOButton provider="google">Continue with Google</SSOButton>
        <SSOButton provider="microsoft">Log in with Microsoft</SSOButton>
        <SSOButton provider="github">Sign in with GitHub</SSOButton>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Disabled State</h3>
      <div className={styles.ssoButtonsDemo}>
        <SSOButton provider="google" disabled />
        <SSOButton provider="microsoft" disabled />
        <SSOButton provider="github" disabled />
      </div>
    </div>
  </section>
);
